function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12.3008,
  r: 12,
  fill: "url(#paint0_linear_796_1871)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.71372 11.5685H14.7139C14.8709 11.5685 15.0184 11.495 15.1129 11.3695C15.2074 11.2445 15.2379 11.082 15.1944 10.9315L14.1944 7.43137C14.1333 7.21686 13.9368 7.06836 13.7138 7.06836H10.7138C10.4907 7.06836 10.2942 7.21686 10.2332 7.43137L9.23321 10.9315C9.19021 11.082 9.22021 11.244 9.31471 11.3695C9.40921 11.495 9.55672 11.5685 9.71372 11.5685ZM11.1423 8.5684H12.2853L11.8568 10.0684H10.7138L11.1423 8.5684Z",
  fill: "url(#paint1_linear_796_1871)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1944 12.4319C11.1333 12.2169 10.9368 12.0684 10.7138 12.0684H7.71375C7.49075 12.0684 7.29424 12.2169 7.23324 12.4314L6.23321 15.9315C6.19021 16.082 6.22021 16.244 6.31471 16.3695C6.40921 16.495 6.55672 16.5685 6.71372 16.5685H11.7139C11.8709 16.5685 12.0184 16.495 12.1129 16.3695C12.2074 16.2445 12.2379 16.082 12.1944 15.9315L11.1944 12.4319ZM9.2853 15.0684H8.14226L8.57078 13.5684H9.71381L9.2853 15.0684Z",
  fill: "url(#paint2_linear_796_1871)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.1944 15.9315L17.1944 12.4314C17.1328 12.2169 16.9368 12.0684 16.7138 12.0684H13.7138C13.4907 12.0684 13.2942 12.2169 13.2332 12.4314L12.2332 15.9315C12.1902 16.082 12.2202 16.244 12.3147 16.3695C12.4092 16.495 12.5567 16.5685 12.7137 16.5685H17.7139C17.8709 16.5685 18.0184 16.495 18.1129 16.3695C18.2074 16.244 18.2379 16.0815 18.1944 15.9315ZM15.3568 15.0679H14.2138L14.6423 13.5679H15.7853L15.3568 15.0679Z",
  fill: "url(#paint3_linear_796_1871)"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_796_1871",
  x1: 12,
  y1: 0.300781,
  x2: 12,
  y2: 24.3008,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD700"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#AF8714"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_796_1871",
  x1: 12.2139,
  y1: 7.06836,
  x2: 12.2139,
  y2: 11.5685,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_796_1871",
  x1: 9.2139,
  y1: 12.0684,
  x2: 9.2139,
  y2: 16.5685,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_796_1871",
  x1: 15.2139,
  y1: 12.0684,
  x2: 15.2139,
  y2: 16.5685,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white"
})));

var SvgGoldCurrency = (_ref) => {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoldCurrency, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gold_currency.dee5db81.svg";
export { ForwardRef as ReactComponent };